<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
  <el-form
    :model="form"
    :rules="rules"
    ref="form"
    label-width="16rem"
    style="width: 65%"
  >
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">LED信息发布详情</div>
      </zj-layout-header>
    </zj-layout-container>
    <el-row>
      <el-col :span="12">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" :disabled="!IsEdit"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" :rows="4" v-model="form.content" :disabled="!IsEdit"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form-item label="含通告的LED屏" prop="inform">
            <treeselect
              v-model="form.inform"
              :options="treeData"
              :disabled="!IsEdit"
              :multiple="true"
              :alwaysOpen="true"
              noResultsText="暂无选择项"
              placeholder="请选择"
            />
          </el-form-item>
      </el-col>
    </el-row>
    
    <el-form-item class="left">
      <el-button @click="onBack()">返回</el-button>
      <el-button
        type="primary"
        @click="send()"
        :disabled="!IsEdit"
        v-if="IsEdit"
        >一键发送</el-button
      >
    </el-form-item>
  </el-form>
  </div>
</template>
<script>
// import MyApis from "../../../apis";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "LedMassMessageInfo",
  controller: "UI",
  action: "LedMassMessageInfo",
  components: {
    Treeselect
  },
  data() {
    return {
      IsEdit: false,
      form: {
        title: null,
        content: null,
        inform: null,
      },
      treeData: []
    };
  },
  created: function() {
    this.getLedList();
    if(this.$route.query.type == 'query'){
      this.search();
      this.IsEdit = false;
    }else{
      this.IsEdit = true;
    }
  },
  methods: {
    // led列表
    getLedList(){
      
    },
    search(){

    },
    onBack(){
      this.$router.go(-1);
    },
    send(){

    }
  },
};
</script>
